<template>
  <!-- eslint-disable max-len -->
  <svg
    :aria-label="ariaLabel"
    :height="height"
    :width="width"
    viewBox="0 0 50 50"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title lang="en">Fullscreen icon</title>
    <g v-if="isFullscreen">
      <path
        fill="#FFFFFF"
        d="M49.9,8c0-0.4-0.1-0.9-0.3-1.4c-1.3-3.5-3.5-5.5-7-6.2c-1.5-0.4-3-0.5-4.3-0.5l-7,0.3
      c-5.9,0.3-10.4,0.3-13-0.1L16-0.1c-1.3,0-2.9,0-4.7,0.1c-2,0.1-3.7,0.3-4.7,0.4C4.7,0.5,3,1.5,1.9,3.3c-0.6,0.9-1,1.8-1.3,2.6
      C0,8.1-0.3,10-0.3,11.5c-0.1,2.3-0.1,4.3,0,6.2C-0.2,19,0,21.3,0,25.1l-0.1,14.1c0,0.8,0.1,1.8,0.3,3.1c0.3,1.4,0.8,2.6,1.5,3.6
      c0.4,0.5,1,1.3,2,2.1c1.8,1.6,3.8,2.4,6.3,2.1l13-0.8c0.5,0,3.2,0.1,7.7,0.4C33,50,36.4,50,41.1,50H43c1.6-0.1,3-0.8,4.2-1.8
      c1.1-1,1.9-2.4,2.3-4c0.3-1,0.3-2.8,0.3-5.3c-0.1-2.5-0.1-4-0.1-4.8C49.8,31.3,50,27.9,50,24L49.9,8z"
      />
      <path
        fill="#231F20"
        d="M43,0.5C41.4,0.1,40,0,39.1,0c-2.8,0-4.9,0-6.4,0.1s-3.4,0.3-5.6,0.3c-2.4,0-4.3,0-5.6,0c-0.6,0-1,0-1.4-0.1
      C18.7,0,16.8-0.1,14.5,0C11.2,0.3,8.7,0.4,7,0.5C4.7,0.7,2.9,1.8,1.6,3.9c-0.3,0.4-0.5,1-0.9,1.9c-0.5,1.8-0.9,3.6-1,5.5
      c0,3.4,0,5.7,0.1,6.7C0,19.4,0,21.4,0,24.1l-0.1,14.6c0,0.8,0.1,1.9,0.3,3.5c0.1,1.5,0.8,2.9,1.9,4.3c0.4,0.5,1,1.1,1.9,1.9
      c1.6,1.5,3.5,2.1,5.9,1.9l6.1-0.5c2-0.3,4.6-0.4,7.5-0.4c0.6,0,3,0.1,7.5,0.4c2.3,0.1,5.7,0.1,10.4,0.1H43c1.8-0.1,3.2-0.8,4.4-1.8
      c1.1-1,1.9-2.4,2.3-4.2c0.3-1.4,0.4-3.1,0.1-5.3c-0.1-1.9-0.3-3.4-0.1-4.8c0.3-2.1,0.4-4.9,0.3-8.4l0.3-16.6c0-2-0.8-3.9-2-5.4
      C46.6,1.9,45,0.9,43,0.5 M30.8,1.5l8.6-0.1c1.3,0,2.5,0.1,3.7,0.5c1.8,0.4,3.2,1.4,4.2,2.9c0.9,1.3,1.4,2.8,1.5,4.4V10
      c-0.1,2.1-0.3,4.8-0.3,7.9l-0.1,13.8c-0.1,3.5-0.1,6.2,0,7.9c0.1,0.9,0.1,1.6,0,2.4c0,0.5,0,1.1-0.3,1.6c-0.6,3-2.4,4.7-5.6,4.8
      L32,48.3c-1.4,0-2.4,0-3.2-0.1c-3.7-0.3-7.5-0.3-11.1,0l-8.5,0.6c-1.4-0.1-2.7-0.5-3.7-1.4l-1.6-1.5c-1.1-1.1-1.9-2.8-2.1-4.8
      l-0.3-29c0-1.1,0.1-2.8,0.6-4.8c0.4-1.6,1-2.9,1.9-3.8C4.8,2.7,5.8,2.2,6.8,2c3.4-0.4,5.9-0.5,7.7-0.5C20,1.7,25.4,1.7,30.8,1.5z"
      />
      <path
        fill="#231F20"
        d="M11.9,19.4c-0.1,0.1-0.3,0.4-0.3,0.8c0,0.1,0.1,0.3,0.4,0.6c1.3,0.1,2.8,0.1,4.6,0.1c1.6,0,2.9-0.1,3.8-0.4
      c0.3-0.3,0.6-0.7,0.7-1.3l0.1-6.3l-0.1-0.3c0-0.3-0.3-0.5-0.5-0.6c-0.3-0.1-0.5-0.1-0.8,0.1l-1.6,1.4c-0.6,0.4-1,0.6-1.1,0.6
      l-0.5-0.3l-5.4-5.7c-0.4-0.4-0.6-0.6-1-0.6c-0.3,0-0.6,0.3-1,0.6L8.1,9.4C8,9.8,8,10.3,8.4,10.8c0,0.1,1,1.1,2.8,3.1
      c1.6,1.9,2.5,3,2.7,3.4L11.9,19.4z"
      />
      <path
        fill="#FFDB25"
        d="M14.3,18.6c-0.1,0.1-0.1,0.2-0.1,0.3c0.1,0.1,0.3,0.3,0.4,0.3l4.4-0.1l0.4-0.3l0.3-0.9
      c0.1-1.6,0.1-2.9,0-3.9c-0.3-0.1-0.4-0.1-0.5-0.1c-0.3,0.1-0.6,0.4-1.1,0.8c-0.5,0.4-0.9,0.6-1.3,0.8c-0.4-0.1-1.4-1.1-3.3-3.1
      s-2.9-3.1-3.2-3.3c-0.1,0-0.3,0.1-0.5,0.1L9.3,9.7c0,0.1,0.3,0.5,0.6,1.1c0.1,0.3,1.8,2.1,5.1,5.7c0.3,0.4,0.3,0.6,0,1
      C15.1,17.7,14.8,18.1,14.3,18.6z"
      />
      <path
        fill="#231F20"
        d="M8,40.9l1.3,1.2c0.4,0.1,0.9,0,1.4-0.3c0.1,0,1.1-1,3.2-2.8c1.9-1.6,3-2.5,3.4-2.6l2,1.8
      c0.1,0.1,0.4,0.3,0.8,0.3c0.1,0,0.3-0.1,0.6-0.4c0.1-1.3,0.1-2.8,0.1-4.4s-0.1-2.9-0.4-3.8c-0.4-0.4-0.8-0.6-1.4-0.8L12.7,29
      l-0.3,0.1c-0.3,0-0.5,0.3-0.6,0.5c-0.1,0.3-0.1,0.5,0,0.8l1.4,1.7c0.4,0.6,0.6,1,0.6,1.1l-0.3,0.5l-5.6,5.4c-0.4,0.4-0.6,0.6-0.6,1
      C7.4,40.3,7.6,40.5,8,40.9z"
      />
      <path
        fill="#FFDB25"
        d="M9.1,40.3l0.5,0.5c0.3,0,0.4-0.1,0.6-0.3c0.3-0.1,0.4-0.3,0.5-0.4c3.5-3.3,5.3-4.9,5.6-5
      c0.4-0.3,0.6-0.3,1,0l1.1,0.8c0.1,0.1,0.3,0.1,0.4,0.1c0.2-0.2,0.3-0.3,0.3-0.4L19,31.2l-0.3-0.4l-0.9-0.3c-1.6-0.1-2.9-0.1-3.9,0
      c-0.1,0.3-0.1,0.5-0.1,0.6c0.1,0.3,0.4,0.5,0.8,1c0.4,0.5,0.6,0.9,0.8,1.3c-0.1,0.4-1.1,1.4-3,3.3c-2,1.9-3.2,3-3.3,3.1
      C9,40,9,40.3,9.1,40.3z"
      />
      <path
        fill="#231F20"
        d="M42.3,40.8c0.1-0.4,0-0.9-0.3-1.4c0-0.1-1-1.1-2.8-3.1c-1.6-1.9-2.5-3-2.7-3.4l1.8-2
      c0.1-0.3,0.3-0.5,0.3-0.8c0-0.1-0.1-0.3-0.4-0.6c-1.3-0.1-2.8-0.1-4.4-0.1c-1.6,0-2.9,0.1-3.8,0.4c-0.5,0.4-0.8,0.9-0.8,1.4
      l-0.1,6.3l0.1,0.3c0,0.3,0.3,0.5,0.5,0.6c0.3,0.1,0.5,0.1,0.8,0l1.6-1.4c0.5-0.4,0.9-0.6,1.1-0.6l0.5,0.3l5.6,5.3
      c0.4,0.4,0.8,0.6,1,0.6c0.3,0,0.6-0.3,1-0.6L42.3,40.8z"
      />
      <path
        fill="#FFDB25"
        d="M41.1,40.4c0-0.3-0.1-0.4-0.3-0.6c-0.1-0.1-0.3-0.3-0.5-0.5c-3.2-3.5-4.9-5.3-5.1-5.5c-0.1-0.4-0.1-0.8,0-1
      l0.8-1c0.1-0.1,0.1-0.3,0.1-0.5C36,31.2,36,31,35.8,31l-4.6,0.1l-0.4,0.3l-0.4,0.9c-0.1,1.6-0.1,2.9,0,3.9c0.3,0.1,0.5,0.1,0.6,0.1
      c0.3-0.1,0.5-0.4,1-0.8s0.9-0.6,1.3-0.8c0.4,0.1,1.4,1.1,3.3,3c1.9,2.1,3,3.1,3.2,3.3c0.3,0,0.4,0,0.5-0.1
      C40.7,40.9,40.8,40.8,41.1,40.4z"
      />
      <path
        fill="#231F20"
        d="M29.5,20.5c0.4,0.4,0.8,0.6,1.4,0.8l6.3,0.1l0.3-0.1c0.3,0,0.5-0.3,0.6-0.5c0.1-0.2,0.1-0.5-0.1-0.8
      l-1.4-1.6c-0.4-0.5-0.6-0.9-0.6-1.1l0.3-0.5l5.7-5.4c0.4-0.4,0.6-0.8,0.6-1s-0.3-0.6-0.6-1l-1.3-1.3c-0.4-0.1-0.9,0-1.4,0.3
      c-0.1,0-1.1,1-3.2,2.8c-1.9,1.6-3,2.5-3.4,2.6l-2-1.8c-0.3-0.3-0.5-0.3-0.8-0.3c-0.1,0-0.3,0.1-0.6,0.4C29,15.9,29.1,18.7,29.5,20.5
      z"
      />
      <path
        fill="#FFDB25"
        d="M31,19.7l0.9,0.3c1.6,0.1,2.9,0.1,3.9,0c0.1-0.3,0.1-0.5,0-0.6c-0.1-0.3-0.4-0.5-0.8-1
      c-0.4-0.5-0.6-0.9-0.8-1.3c0.1-0.4,1.1-1.4,3.2-3.3s3.2-2.9,3.3-3.1l-0.1-0.5L40,9.6c-0.1,0-0.5,0.3-1.1,0.8c-0.3,0.1-2,1.8-5.6,5
      c-0.5,0.1-0.9,0.1-1.1,0l-1-0.8c-0.1-0.1-0.3-0.1-0.5-0.1c-0.1,0.1-0.3,0.1-0.3,0.3l0.1,4.5L31,19.7z"
      />
    </g>
    <g v-else>
      <path
        fill="#FFFFFF"
        d="M49.9,8c0-0.4-0.1-0.9-0.3-1.4c-1.3-3.5-3.5-5.5-7-6.2c-1.5-0.4-3-0.5-4.3-0.5l-7,0.3
      c-5.9,0.3-10.4,0.3-13-0.1L16-0.1c-1.3,0-2.9,0-4.7,0.1c-2,0.1-3.7,0.3-4.7,0.4C4.7,0.5,3,1.5,1.9,3.3c-0.6,0.9-1,1.8-1.3,2.6
      C0,8.1-0.3,10-0.3,11.5c-0.1,2.3-0.1,4.3,0,6.2C-0.2,19,0,21.3,0,25.1l-0.1,14.1c0,0.8,0.1,1.8,0.3,3.1c0.3,1.4,0.8,2.6,1.5,3.6
      c0.4,0.5,1,1.3,2,2.1c1.8,1.6,3.8,2.4,6.3,2.1l13-0.8c0.5,0,3.2,0.1,7.7,0.4C33,50,36.4,50,41.1,50H43c1.6-0.1,3-0.8,4.2-1.8
      c1.1-1,1.9-2.4,2.3-4c0.3-1,0.3-2.8,0.3-5.3c-0.1-2.5-0.1-4-0.1-4.8C49.8,31.3,50,27.9,50,24L49.9,8z"
      />
      <path
        fill="#231F20"
        d="M43,0.5C41.4,0.1,40,0,39.1,0c-2.8,0-4.9,0-6.4,0.1s-3.4,0.3-5.6,0.3c-2.4,0-4.3,0-5.6,0c-0.6,0-1,0-1.4-0.1
      C18.7,0,16.8-0.1,14.5,0C11.2,0.3,8.7,0.4,7,0.5C4.7,0.7,2.9,1.8,1.6,3.9c-0.3,0.4-0.5,1-0.9,1.9c-0.5,1.8-0.9,3.6-1,5.5
      c0,3.4,0,5.7,0.1,6.7C0,19.4,0,21.4,0,24.1l-0.1,14.6c0,0.8,0.1,1.9,0.3,3.5c0.1,1.5,0.8,2.9,1.9,4.3c0.4,0.5,1,1.1,1.9,1.9
      c1.6,1.5,3.5,2.1,5.9,1.9l6.1-0.5c2-0.3,4.6-0.4,7.5-0.4c0.6,0,3,0.1,7.5,0.4c2.3,0.1,5.7,0.1,10.4,0.1H43c1.8-0.1,3.2-0.8,4.4-1.8
      c1.1-1,1.9-2.4,2.3-4.2c0.3-1.4,0.4-3.1,0.1-5.3c-0.1-1.9-0.3-3.4-0.1-4.8c0.3-2.1,0.4-4.9,0.3-8.4l0.3-16.6c0-2-0.8-3.9-2-5.4
      C46.6,1.9,45,0.9,43,0.5 M30.8,1.5l8.6-0.1c1.3,0,2.5,0.1,3.7,0.5c1.8,0.4,3.2,1.4,4.2,2.9c0.9,1.3,1.4,2.8,1.5,4.4V10
      c-0.1,2.1-0.3,4.8-0.3,7.9l-0.1,13.8c-0.1,3.5-0.1,6.2,0,7.9c0.1,0.9,0.1,1.6,0,2.4c0,0.5,0,1.1-0.3,1.6c-0.6,3-2.4,4.7-5.6,4.8
      L32,48.3c-1.4,0-2.4,0-3.2-0.1c-3.7-0.3-7.5-0.3-11.1,0l-8.5,0.6c-1.4-0.1-2.7-0.5-3.7-1.4l-1.6-1.5c-1.1-1.1-1.9-2.8-2.1-4.8
      l-0.3-29c0-1.1,0.1-2.8,0.6-4.8c0.4-1.6,1-2.9,1.9-3.8C4.8,2.7,5.8,2.2,6.8,2c3.4-0.4,5.9-0.5,7.7-0.5C20,1.7,25.4,1.7,30.8,1.5z"
      />
      <path
        fill="#231F20"
        d="M17.3,9c0.1-0.1,0.3-0.4,0.3-0.8c0-0.1-0.1-0.3-0.4-0.6c-1.3-0.1-2.8-0.1-4.6-0.1c-1.6,0-2.9,0.1-3.8,0.4
      C8.5,8.2,8.2,8.6,8.1,9.2L8,15.5l0.1,0.3c0,0.3,0.3,0.5,0.5,0.6c0.3,0.1,0.5,0.1,0.8-0.1l1.6-1.4c0.6-0.4,1-0.6,1.1-0.6l0.5,0.3
      l5.4,5.7c0.4,0.4,0.6,0.6,1,0.6c0.3,0,0.6-0.3,1-0.6l1.1-1.3c0.1-0.4,0.1-0.9-0.3-1.4c0-0.1-1-1.1-2.8-3.1c-1.6-1.9-2.5-3-2.7-3.4
      L17.3,9z"
      />
      <path
        fill="#FFDB25"
        d="M14.9,9.8C15,9.7,15,9.6,15,9.5c-0.1-0.1-0.3-0.3-0.4-0.3l-4.4,0.1L9.8,9.6l-0.3,0.9c-0.1,1.6-0.1,2.9,0,3.9
      c0.3,0.1,0.4,0.1,0.5,0.1c0.3-0.1,0.6-0.4,1.1-0.8c0.5-0.4,0.9-0.6,1.3-0.8c0.4,0.1,1.4,1.1,3.3,3.1s2.9,3.1,3.2,3.3
      c0.1,0,0.3-0.1,0.5-0.1l0.5-0.5c0-0.1-0.3-0.5-0.6-1.1c-0.1-0.3-1.8-2.1-5.1-5.7c-0.3-0.4-0.3-0.6,0-1C14.1,10.7,14.4,10.3,14.9,9.8
      z"
      />
      <path
        fill="#231F20"
        d="M20.1,30.2L18.8,29c-0.4-0.1-0.9,0-1.4,0.3c-0.1,0-1.1,1-3.2,2.8c-1.9,1.6-3,2.5-3.4,2.6l-2-1.8
      c-0.1-0.1-0.4-0.3-0.8-0.3c-0.1,0-0.3,0.1-0.6,0.4c-0.1,1.3-0.1,2.8-0.1,4.4s0.1,2.9,0.4,3.8c0.4,0.4,0.8,0.6,1.4,0.8l6.3,0.1
      l0.3-0.1c0.3,0,0.5-0.3,0.6-0.5c0.1-0.3,0.1-0.5,0-0.8L14.9,39c-0.4-0.6-0.6-1-0.6-1.1l0.3-0.5l5.6-5.4c0.4-0.4,0.6-0.6,0.6-1
      C20.7,30.8,20.5,30.6,20.1,30.2z"
      />
      <path
        fill="#FFDB25"
        d="M19,30.8l-0.5-0.5c-0.3,0-0.4,0.1-0.6,0.3c-0.3,0.1-0.4,0.3-0.5,0.4c-3.5,3.3-5.3,4.9-5.6,5
      c-0.4,0.3-0.6,0.3-1,0l-1.1-0.8c-0.1-0.1-0.3-0.1-0.4-0.1C9.1,35.3,9,35.4,9,35.5l0.1,4.4l0.3,0.4l0.9,0.3c1.6,0.1,2.9,0.1,3.9,0
      c0.1-0.3,0.1-0.5,0.1-0.6c-0.1-0.3-0.4-0.5-0.8-1c-0.4-0.5-0.6-0.9-0.8-1.3c0.1-0.4,1.1-1.4,3-3.3c2-1.9,3.2-3,3.3-3.1
      C19.1,31.1,19.1,30.8,19,30.8z"
      />
      <path
        fill="#231F20"
        d="M29.1,31.2c-0.1,0.4,0,0.9,0.3,1.4c0,0.1,1,1.1,2.8,3.1c1.6,1.9,2.5,3,2.7,3.4l-1.8,2
      c-0.1,0.3-0.3,0.5-0.3,0.8c0,0.1,0.1,0.3,0.4,0.6c1.3,0.1,2.8,0.1,4.4,0.1c1.6,0,2.9-0.1,3.8-0.4c0.5-0.4,0.8-0.9,0.8-1.4l0.1-6.3
      l-0.1-0.3c0-0.3-0.3-0.5-0.5-0.6c-0.3-0.1-0.5-0.1-0.8,0L39.3,35c-0.5,0.4-0.9,0.6-1.1,0.6l-0.5-0.3L32.1,30c-0.4-0.4-0.8-0.6-1-0.6
      c-0.3,0-0.6,0.3-1,0.6L29.1,31.2z"
      />
      <path
        fill="#FFDB25"
        d="M30.3,31.6c0,0.3,0.1,0.4,0.3,0.6c0.1,0.1,0.3,0.3,0.5,0.5c3.2,3.5,4.9,5.3,5.1,5.5c0.1,0.4,0.1,0.8,0,1
      l-0.8,1c-0.1,0.1-0.1,0.3-0.1,0.5c0.1,0.1,0.1,0.3,0.3,0.3l4.6-0.1l0.4-0.3l0.4-0.9c0.1-1.6,0.1-2.9,0-3.9c-0.3-0.1-0.5-0.1-0.6-0.1
      c-0.3,0.1-0.5,0.4-1,0.8s-0.9,0.6-1.3,0.8c-0.4-0.1-1.4-1.1-3.3-3c-1.9-2.1-3-3.1-3.2-3.3c-0.3,0-0.4,0-0.5,0.1
      C30.7,31.1,30.6,31.2,30.3,31.6z"
      />
      <path
        fill="#231F20"
        d="M42.2,9c-0.4-0.4-0.8-0.6-1.4-0.8l-6.3-0.1l-0.3,0.1c-0.3,0-0.5,0.3-0.6,0.5s-0.1,0.5,0.1,0.8l1.4,1.6
      c0.4,0.5,0.6,0.9,0.6,1.1l-0.3,0.5l-5.7,5.4c-0.4,0.4-0.6,0.8-0.6,1s0.3,0.6,0.6,1l1.3,1.3c0.4,0.1,0.9,0,1.4-0.3
      c0.1,0,1.1-1,3.2-2.8c1.9-1.6,3-2.5,3.4-2.6l2,1.8c0.3,0.3,0.5,0.3,0.8,0.3c0.1,0,0.3-0.1,0.6-0.4C42.7,13.6,42.6,10.8,42.2,9z"
      />
      <path
        fill="#FFDB25"
        d="M40.7,9.8l-0.9-0.3c-1.6-0.1-2.9-0.1-3.9,0c-0.1,0.3-0.1,0.5,0,0.6c0.1,0.3,0.4,0.5,0.8,1
      c0.4,0.5,0.6,0.9,0.8,1.3c-0.1,0.4-1.1,1.4-3.2,3.3s-3.2,2.9-3.3,3.1l0.1,0.5l0.6,0.6c0.1,0,0.5-0.3,1.1-0.8c0.3-0.1,2-1.8,5.6-5
      c0.5-0.1,0.9-0.1,1.1,0l1,0.8C40.6,15,40.8,15,41,15c0.1-0.1,0.3-0.1,0.3-0.3l-0.1-4.5L40.7,9.8z"
      />
    </g>
  </svg>
</template>

<script>
import BaseIcon from 'mixins/BaseIcon';

export default {
  mixins: [BaseIcon],
  props: {
    ariaLabel: {
      type: String,
      default: 'Fullscreen'
    },
    isFullscreen: {
      type: Boolean,
      default: false
    }
  }
};
</script>
